import { TextAreaProps } from "antd/lib/input";
import TextArea from "antd/es/input/TextArea";
import styles from "./textArea.module.css";

type DefaultTextAreaProps = TextAreaProps;
export const DefaultTextArea: React.FC<DefaultTextAreaProps> = ({ placeholder, ...props }) => {
  const hasValue = props.value !== undefined && props.value !== null && props.value !== "";

  return (
    <label className={styles.textAreaBlock}>
      <TextArea {...props} className={styles.textArea} variant="outlined" />

      {placeholder && <span className={`${styles.label} ${hasValue ? styles.labelTop : ""}`}>{placeholder}</span>}
    </label>
  );
};
